export default __webpack_public_path__ + "static/media/sync-vs-async.d505d894.png";